





























import { defineComponent, PropType, ref } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import ImageCropper from "@/components/ImageCropper";
import { CropConfig } from "@/components/ImageCropper/types";
import ModalView from "@/components/ModalView";

export default defineComponent({
  name: "BannerCropModal",
  components: { ImageCropper, ModalView },
  props: {
    show: { type: Boolean, required: true },
    banner: { type: String, required: true },
    user: { type: Object as PropType<UserPublicData>, required: true },
    loading: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const cropConfig: CropConfig = {
      exportWidth: 1200,
      exportHeight: 372,
      aspectRatio: 1200 / 372,
      cropZoneWidth: 600,
      cropZoneHeight: 186,
    };

    const cropperWrapperWidth = ref(cropConfig.cropZoneWidth);

    const handleCropImage = (blob: Blob) => {
      const file = new File([blob], `${props.user.screenName}_banner.jpg`, { type: "image/jpeg" });
      emit("imageCropped", file);
    };
    const handleCropBox = (data: Cropper.CropBoxData) => {
      cropperWrapperWidth.value = data.width;
    };

    return { cropConfig, handleCropImage, handleCropBox, cropperWrapperWidth };
  },
});
